import { DSButton } from "@components/design-system/molecules";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCurrentUser, useNoteUsage, usePreferences } from "@hooks";
import { useFlags } from "launchdarkly-react-client-sdk";

import Twemoji from "../../Twemoji";

export default function FirstTimeTourBanner() {
  const { releaseWebEnableFtueTour } = useFlags();
  const { user } = useCurrentUser();
  const { totalNotesCreated } = useNoteUsage();
  const { setFirstTimeTourDisabled } = usePreferences();

  if (
    !releaseWebEnableFtueTour ||
    totalNotesCreated === undefined ||
    totalNotesCreated > 10
  ) {
    return null;
  }

  let currentTimeInHours = new Date().getHours();
  const isDay = currentTimeInHours >= 3 && currentTimeInHours <= 16;
  let infoText =
    "It looks like you haven't made many notes with Scribenote. Try recording your appointments by clicking the big purple button!";

  return (
    <div className="rounded-xl bg-brand-subtle p-6 flex flex-col md:flex-row items-start md:items-center gap-4 shadow-xs shadow-secondary">
      <div className="flex-1 space-y-2">
        <h3 className="text-primary">
          {isDay ? (
            <span>
              Hello {user?.firstName}! <Twemoji emoji={"👋"} />
            </span>
          ) : (
            <span>
              Good Evening {user?.firstName}! <Twemoji emoji={"✨"} />
            </span>
          )}
        </h3>
        <h5 className="text-secondary text-sm lg:text-base">
          <FontAwesomeIcon icon={faInfoCircle} /> {infoText}
        </h5>
      </div>

      <DSButton
        variant="primary"
        dataTestId="ftue-show-me-how"
        onClick={() => {
          setFirstTimeTourDisabled(false);
        }}
      >
        Show Me How
      </DSButton>
    </div>
  );
}
